import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigurationService } from '@app/_shared';
import { NetProfitResponse, PdfReportResponse } from '../margin-summary.interfaces';
import { tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { StrategyWisePnlresponse, strategyWisePnlRequest } from '@app/modules/trading/modules/profile/components/earnings-reports/earnings-reports.constants';
import { cloneDeep } from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class MarginSummaryService {

  userProfitArray: NetProfitResponse;
  strategyWisePnl: NetProfitResponse;
  previousStrategyRequest: strategyWisePnlRequest;

  // Persist visibility and data states across component destruction
  allBrokerMargins: boolean = false;
  brokerMarginsData: { 
    [broker_id: string]: {
      funds_available: number | null;
      isVisible: boolean;
    }
  } = {};

  // Persist throttle maps across component destruction
  brokerThrottleMap: Map<string, number> = new Map(); // Map to track last refresh time per broker (key: broker_id)
  brokerCardRefreshTooltipMap: Map<string, string> = new Map(); // Cache tooltip text per broker (key: broker_id)
  readonly THROTTLE_DURATION = 30000; // 30 seconds in milliseconds

  constructor(
    private http: HttpClient,
    private configurationService: ConfigurationService,
  ) { }

  getNetUserProfit() {
    if (this.userProfitArray) {
      return of(this.userProfitArray);
    }

    return this.http.get<NetProfitResponse>(this.configurationService.applicationUrls.netUserProfit)
      .pipe(
        tap((res) => {
          this.userProfitArray = res;
        })
      );
  }

  getDayWiseStrategyPnl(request: strategyWisePnlRequest) {
    if (this.previousStrategyRequest
      && this.previousStrategyRequest.from_date === request.from_date
      && this.previousStrategyRequest.to_date === request.to_date 
      && this.previousStrategyRequest.strategy_name === request.strategy_name
      && this.previousStrategyRequest?.is_original === request?.is_original
      && this.previousStrategyRequest?.portfolio_creation_type === request?.portfolio_creation_type
      && this.previousStrategyRequest.days === request.days && this.previousStrategyRequest.broker === request.broker) {
      return of(this.strategyWisePnl);
    }

    this.previousStrategyRequest = cloneDeep(request);

    return this.http.get<NetProfitResponse>(this.configurationService.applicationUrls.netUserProfit, {
      params: { 
        ...request
       } as any
    })
      .pipe(
        tap((res) => {
          this.strategyWisePnl = res;
        })
      );
  }

  getPdfReport(request: strategyWisePnlRequest) {
    return this.http.get<PdfReportResponse>(this.configurationService.applicationUrls.exportReportAsPdf , {
      params: { ...request } as any
    });
  }

  getStrategyPnlDetails(request: strategyWisePnlRequest) {
    return this.http.get<StrategyWisePnlresponse[]>(this.configurationService.applicationUrls.strategyWisePnl, {
      params: { ...request } as any
    });
  }
}
